<template>
    <div id="grade-test p-pb-6" >
        <data-table-original
                :key="tableKey"

                :defaultSortOrder="-1"
                :sortOrder="-1"
                :loading="loading"
                style="{'padding-button': '50px'}"
                editMode="cell"
                @cell-edit-complete="onCellEditComplete"
                @cell-edit-cancel="onCellEditCancel($event)"
                dataKey="pupil"
                :filters.sync="filters"
                filterDisplay="menu"
                class="
                p-pb-6
          p-datatable-sm
        "
                scrollHeight="70vh"

                :scrollable="true" scrollDirection="both"
                :value="testList"
                :stripedRows="true"
                showGridlines
                sortMode="multiple"
                removableSort
        >


            <template #header>
                <div class="scale-down p-grid p-jc-center">
                    <div  v-if="user.role === 'ADMIN'" class="p-p-2">
                        <Checkbox id="isTeacherMode" v-model="isTeacherMode" :binary="true" />
                        <label class="p-p-2" for="isTeacherMode">מצב מורה</label>
                    </div>
                    <div v-if="user.role === 'ADMIN' || insertManyAllowEnv" class="p-p-2">

                        <Checkbox id="isInsertManyMode" v-model="isInsertManyMode" :binary="true" />
                        <label class="p-p-2" for="isInsertManyMode">מילוי מרובה</label>

                    </div>
                </div>
                <div class="scale-down p-grid p-jc-center p-p-3">


                    <div v-if="isTeacherMode" class="p-p-2">
                        מורה
                        <select-teacher @onSelect="teacherSelected" navigate-buttons useStore storage-name="grade-test-teacher" default-value="teacher"/>
                    </div>
                    <div class="p-p-2">
                        כיתה
                        <select-grade :specificOptions="specificGrades" navigate-buttons useStore storage-name="grade-test-grade" v-model="grade"/>
                    </div>

                    <div class="p-p-2">
                        מקצוע
                        <select-lesson :specificOptions="specificLessons"  navigate-buttons useStore storage-name="grade-test-lesson" v-model="subject"/>
                    </div>
                    <div class="p-p-2">
                        מתאריך
                        <select-date touchUI v-model="startDate" />

                    </div>
                    <div class="p-p-2">
                        עד תאריך
                        <select-date touchUI v-model="endDate"  />
                    </div>
<!--                    <div class="p-p-2 p-grid p-ai-end ">-->
<!--                        <Button class="p-mr-3"  icon="pi pi-search"  label="חפש" @click="fetchData"></Button>-->
<!--                    </div>-->

                    <div class="p-p-2 p-grid p-ai-end ">
                        <Button class="p-mr-3 p-button-success" icon="pi pi-plus" label="מבחן חדש" @click="openAddNameDialog"></Button>
                    </div>



                </div>
                <div v-if="isInsertManyMode" class="scale-down p-grid p-jc-center p-p-3">
                    <Textarea place v-model="listToPost"></Textarea>
                    <Button class="p-mr-3"  label="מלא" @click="postMany"></Button>
                </div>
                    <div style="text-align: center !important" :key="detailsKey" v-if="testNames && !loading" class="p-grid  p-jc-center ">
                        <div class="p-col">
                            <h3>  שם המבחן:  </h3>
                            <h3> {{testNames[yPosition] && testNames[yPosition].name }}</h3>
                        </div>
                            <div class="p-col">
                        <h3>  נושא:  </h3>
                        <h3> {{testNames[yPosition] && getLessonName(testNames[yPosition].subject ) }} </h3>
                    </div>
                        <div class="p-col">
                            <h3>  תאריך עדכון:  </h3>
                            <h3> {{testNames[yPosition] && testList[xPosition] && testList[xPosition]['pupil'] && hebrewFullDate(findTestId(testNames[yPosition].id, testList[xPosition]['pupil']).date) }} </h3>
                        </div>

<!--                        <div class="p-col">-->
<!--                            <h4>  תלמיד  </h4>-->
<!--                            <h4> {{testList[xPosition] && getPupilName(testList[xPosition]['pupil'])}} </h4>-->
<!--                        </div>-->
<!--                        <div class="p-col"  >-->
<!--                            <h4>   {[testNames[yPosition]{ }}ניקוד {{[xPosition]}} </h4>-->
<!--                            <h4> {{testList[xPosition] && testList[xPosition]}} </h4>-->
<!--                        </div>-->

<!--                        <div>-->
<!--                            <h4>  מורה מדווח  </h4>-->
<!--                            &lt;!&ndash;                <h4> {{ testList[xPosition]['pupil'] && getTeacherName(findTestId(testNames[yPosition].id, testList[xPosition]['pupil']).user)}} </h4>&ndash;&gt;-->
<!--                        </div>-->

                    </div>

                <!--                <div class="p-grid ">-->
                <!--                    <Button type="button" icon="pi pi-filter-slash" label="נקה סינון" class="p-button-outlined"-->
                <!--                            @click="clearFilter()"/>-->

                <!--&lt;!&ndash;                    <span class="p-input-icon-left">&ndash;&gt;-->
                <!--&lt;!&ndash;                    <i class="pi pi-search"/>&ndash;&gt;-->
                <!--&lt;!&ndash;                </span>&ndash;&gt;-->
                <!--                </div>-->
            </template>
            <template #empty>
               לא נמצאו מבחנים
            </template>
<!--            :styles="{'flex-grow':'1', 'flex-basis':'200px', 'right': '0 !important', 'overflow': 'scroll' , 'padding-bottom': '0.5 !important', 'padding-top': '0.5 !important'}"-->
<!--            :headerStyle="{'flex-grow':'1', 'flex-basis':'200px', 'right': '0 !important', 'overflow': 'scroll' , 'padding-bottom': '0.5 !important', 'padding-top': '0.5 !important'}"-->
<!--            :styles="{ 'right': '0 !important', 'overflow': 'scroll' , 'padding-bottom': '0.5 !important', 'padding-top': '0.5 !important'}"-->
<!--            :headerStyle="{ 'right': '0 !important', 'overflow': 'scroll' , 'padding-bottom': '0.5 !important', 'padding-top': '0.5 !important'}"-->
            <ColumnOriginal
                    :styles="{width:'200px'}"
                    headerStyle="width:200px"

                    :showFilterMatchModes="false"
                    frozen
                    field="pupil" header="תלמיד">
                <template #filter="{filterModel, filterCallback}">
                    <InputText type="text"
                               @input="filterCallback()"
                               v-model="filterModel.value" class="p-column-filter"
                               placeholder="חפש לי שם"/>
                    חפש תלמיד, ניתן להציג כמה תלמידים בהקלדה של התו ׳,׳
                </template>
                <template #body="slotProps">
<!--                    {{slotProps.data}}-->
                    <div :class="pupilClass( slotProps.index)" class="pupil"> {{ getPupilName(slotProps.data.pupil) }}</div>
                </template>


            </ColumnOriginal>


            <!--            <ColumnOriginal-->
            <!--                    sortField="ac72d929-0b56-4877-8b7d-66ab4378717f.score"-->
            <!--                    sortable-->
            <!--                    :styles="{'flex-grow':'1', 'width':'60px', 'overflow': 'hide', 'padding-bottom': '0.5 !important', 'padding-top': '0.5 !important' }"-->
            <!--                    :headerStyle="{'flex-grow':'1', 'width':'60px', 'overflow': 'hide', 'padding-bottom': '0.5', 'padding-top': '0.5 !important' }"-->
            <!--                    :showFilterMatchModes="false"-->

            <!--                    field="ac72d929-0b56-4877-8b7d-66ab4378717f" :header="'ac72d929-0b56-4877-8b7d-66ab4378717f'"-->
            <!--            >-->
            <!--                <template #body="slotProps">-->

            <!--                    <div class="score-wraper" :class="scoreClass( slotProps.data['ac72d929-0b56-4877-8b7d-66ab4378717f'.id].score)">-->
            <!--&lt;!&ndash;                        <div class="score"> {{ slotProps.data[testName.id]  }}</div>&ndash;&gt;-->
            <!--                        <div class="score"> {{ slotProps.data['ac72d929-0b56-4877-8b7d-66ab4378717f'] && slotProps.data['ac72d929-0b56-4877-8b7d-66ab4378717f'].score }}</div>-->
            <!--                        &lt;!&ndash;{{// this.$slots}}&ndash;&gt;-->
            <!--                    </div>-->
            <!--                </template>-->
            <!--                <template #editor="slotProps">-->
            <!--                    <input-->
            <!--                            type="number"-->
            <!--                            class="edit-score input-score"-->
            <!--                            v-model="slotProps.data['ac72d929-0b56-4877-8b7d-66ab4378717f'] && slotProps.data[slotProps.column.field]  "-->
            <!--                            autofocus-->
            <!--                            :class="scoreClass( slotProps.data['ac72d929-0b56-4877-8b7d-66ab4378717f'])"-->
            <!--                    />-->
            <!--                </template>-->
            <!--                <template #filter="{filterModel}">-->
            <!--                    <SliderOriginal v-model="filterModel.value" range class="m-3"></SliderOriginal>-->
            <!--                    <div class="p-pt-5 p-ai-center p-grid p-jc-between ">-->
            <!--                        <span>{{ filterModel.value ? filterModel.value[0] : 0 }}</span>-->
            <!--                        <span>{{ filterModel.value ? filterModel.value[1] : 100 }}</span>-->
            <!--                    </div>-->
            <!--                </template>-->

            <!--            </ColumnOriginal>-->
<!--            :styles="{'width':'5px !important', 'overflow': 'hide', 'padding-bottom': '0.5 !important', 'padding-top': '0.5 !important' }"-->
<!--            :headerStyle="{ 'width':'5px !important', 'overflow': 'hide', 'padding-bottom': '0.5', 'padding-top': '0.5 !important' }"-->
            <ColumnOriginal
                    :styles="{width:'30px'}"
                    headerStyle="width:30px"

                    :sortField="`${testName.id}`"
                    sortable
                    :style="{width:'30px'}"

                    :showFilterMatchModes="false"
                    v-for="(testName, index ) in testNames"
                    :field="testName.id"
                    :header="index + 1"
            >
<!--                :header="testName.name + ' \n ' + hebrewDate(testName.date)"-->

                <template #body="slotProps">
                    <div

                            class="score-wraper "  :class="scoreClass( slotProps.data[testName.id], index, slotProps.index)">
                        <!--                                                <div class="score"> {{ slotProps.data[testName.id] }}</div>-->
                        <!--                        <div class="score"> {{ showScore(slotProps, testName.id)}}</div>-->
<input v-if="slotProps.data.pupil !== '00000'"
            @focusout="focusout"
            :ref="`${index}-${slotProps.index}`"
            @click="inputClick(index, slotProps.index)"
            type="number"
            :id="`${index}-${slotProps.index}`"
            class="edit-score input-score"
            v-model.trim="slotProps.data[testName.id]"
/>
                        <input v-else
v-tooltip="
`${ testNames[index] && testNames[index].name}
${testNames[index] && getLessonName(testNames[index].subject )}
${testNames[index] && hebrewFullDate(testNames[index].date )}`
 "

                            :ref="`${index}-${slotProps.index}`"
                            disabled
                            :id="`${index}-${slotProps.index}`"
                            class="edit-score input-score"
                            v-model.lazy="slotProps.data[testName.id]"
                            />


<!--                        <input-->
<!--                                @focusout="focusout"-->
<!--                                :ref="`${index}-${slotProps.index}`"-->
<!--                                @click="inputClick(index, slotProps.index)"-->
<!--                                type="number"-->
<!--                                :disabled="slotProps.data.pupil === '00000'"-->
<!--                                :id="`${index}-${slotProps.index}`"-->
<!--                                class="edit-score input-score"-->
<!--                                v-model.lazy="slotProps.data[testName.id]"-->
<!--                        />-->

                        <!--{{// this.$slots}}-->
                    </div>
                </template>
                <!--                <template #editor="slotProps">-->

                <!--                    <input-->
                <!--                            type="number"-->
                <!--                            class="edit-score input-score"-->
                <!--                            v-model="slotProps.data[testName.id]"-->
                <!--                            :class="scoreClass( slotProps.data[testName.id] )"-->
                <!--                    />-->
                <!--&lt;!&ndash;                    <div class="score"> {{ slotProps.data[testName.id].score}}</div>&ndash;&gt;-->


                <!--                </template>-->
                <template #filter="{filterModel}">
                    <SliderOriginal v-model="filterModel.value" range class="m-3"></SliderOriginal>
                    <div class="p-pt-5 p-ai-center p-grid p-jc-between ">
                        <span>{{ filterModel.value ? filterModel.value[0] : 0 }}</span>
                        <span>{{ filterModel.value ? filterModel.value[1] : 100 }}</span>
                    </div>
                </template>

            </ColumnOriginal>

            <Dialog
                    showHeader
                    :height="50"
                    :width="20"
                    :scrollable="true"
                    showFooter
                    :title="'הוספת מבחן'"
                    :show="isAddTestNameDialog"
                    @agree="postNewTestName"
                    @cancel="() => isAddTestNameDialog = false">

                <template #content>

                    <div class=" p-p-4 p-grid p-justify-around ">
                        <div class="p-field p-col-12 p-md-6">
                            <h2 style="text-align: center"> {{ subject && subject.hebrewName }}</h2>
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <h2 style="text-align: center"> {{ subject && grade.hebrewName }}</h2>

                        </div>

                        <div class="p-field p-grid p-justify-center p-col-12 p-md-6">
                            <InputText :placeholder="'שם המבחן'" type="text" v-model="nameTestName" autofocus/>
                        </div>
                        <div class="p-field p-grid p-justify-center p-col-12 p-md-6">
                            <select-date
                                    :autoZIndex="true"
                                    :baseZIndex="100"
                                    :touchUI="true"
                                    v-model="dateTestName"
                            />
                        </div>
                    </div>


                </template>
            </Dialog>

        </data-table-original>
    </div>
</template>

<script>
import Dialog from "@/dialogs/Dialog"

import {
    getData,
    getTestNamesOfUser,
    postNewTestName,
    putTest,
    testList,
    testNames
} from "@/views/tests/scoreTest/gradeTest.js";
import {FilterMatchMode} from "primevue/api";
import SelectLesson from "@/components/selects/SelectLesson";
import SelectDate from "@/components/selects/SelectDate";
import SelectGrade from "@/components/selects/SelectGrade";
import {getLessonFullName, getPupilFullName, getTeacherFullName} from "@/utils/parseObj";
import {mapState} from "vuex";
import {dateToOnlyHebrew, dateToFullHebrew} from "@/utils/hebrewDateFormat";

const {v4: uuidv4} = require("uuid");

import {FilterService} from 'primevue/api';
import axios from "axios";
import SelectTeacher from "@/components/selects/SelectTeacher";

FilterService.register('myfilter', (row, input) => {
    let isMatch = false
    if (row === '00000') return true
    if (input === null) return true
    if (input.includes(",")){
        const words = input.split(",")
        words.forEach(word => {
            if (getPupilFullName(row).includes(word.trim())) isMatch = true
        })
    }
   return  getPupilFullName(row).includes(input) || isMatch

})
export default {
    name: "GradeTest",
    components: {SelectTeacher, SelectGrade, SelectDate, SelectLesson, Dialog},
    data() {
        return {
            filters: {},
            grade: null,
            subject: null,
            startDate: null,
            endDate: null,
            loading: false,
            testsPure: null,
            testList: null,
            testNames: null,
            testNamesIds: null,
            isAddTestNameDialog: false,
            nameTestName: null,
            dateTestName: null,
            xPosition: 0,
            yPosition: 0,
            detailsKey: 0,
            tableKey: 0,
            tempScore: null,
            listToPost: [],
            isTeacherMode: false,
            isInsertManyMode: false,
            testNamesOfUser: null,
            teacher: null,
            indexToPost:1,
            isCreated: false

        }
    },
    mounted() {
        document.addEventListener("keydown", this.onKeydown);
        this.initDateRange()

    },
    created() {
        this.isCreated = true
        // this.initDateRange()
    },
    computed: {
        insertManyAllowEnv(){
            return process.env.VUE_APP_INSERT_MANY_TEST || false
        },
        specificGrades(){
            if (this.isTeacherMode){
                if (this.testNamesOfUser){

                    return Object.keys(this.testNamesOfUser)
                }
            }
            return null
        },
        specificLessons(){
            if (this.isTeacherMode){
                if (this.testNamesOfUser){
                    console.log("gradegrade", this.grade)

                    const grade = this.testNamesOfUser[this.grade.id]
                    console.log("gradegrade", grade)
                    if (grade){

                        const lessons = Object.keys(grade)
                        console.log("lessons", lessons)
                        return lessons
                    } else {
                        return []

                    }
                    // return this.testNamesOfUser
                }
            }
            return null
        },
        ...mapState(["user"])
    },
    watch: {
        grade(newValue, oldValue) {
            console.log("newValue",newValue)
            if (this.isCreated && newValue.id){
                this.fetchData()
            }
        },
        subject(newValue, oldValue) {
            if (this.isCreated && newValue.id){
                this.fetchData()
            }
        },
        startDate(newValue, oldValue) {
            if (this.isCreated && newValue){
                this.fetchData()
            }
        },
        endDate(newValue, oldValue) {
            if (this.isCreated && newValue){
                this.fetchData()
            }
        }
    },
    methods: {
        teacherSelected(id){
            this.teacher = id
            this.getTestNamesOfUser()
        },
        async initDateRange(){
            const {data} = await  axios.get(`/report/date-ranges`,)
            // console.log("datadatadata", data)
           const selectedDate = data.find(date => !date.forOldShow && !date.forAdminOnly)
            console.log("selectedDate", selectedDate)
            console.log("selectedDate", selectedDate.startDate)
            console.log("selectedDate", selectedDate.endDate)

            this.startDate = new Date(selectedDate.startDate)
            console.log("selectedDates", this.startDate)
            this.endDate = new Date(selectedDate.endDate)

            console.log("selectedDatee", this.endDate)
            this.tableKey ++

        },
        async postMany() {
            const arrayToPost = this.listToPost.split('\n')
            for (const score of arrayToPost) {
                const a = {
                    index: this.xPosition,
                    newValue: score,
                    field: this.testNames[this.yPosition].id,
                    newData:{
                        pupil: this.testList[this.xPosition]['pupil'],
                    }
                }
                 this.onCellEditComplete(a)
                //             this.navigate("ArrowDown")
            this.navigate("ArrowDown")

            }

            // var event = new KeyboardEvent("keydown", {
            //     key: "ArrowDown",        // The key you want to simulate (Enter in this case)
            //     code: "ArrowDown",       // The key code for Enter
            //     // keyCode: 13,         // The key code for Enter (13 is Enter's key code)
            //     // which: 13,           // The "which" property for Enter key
            //     bubbles: true,       // Event bubbles up the DOM tree
            //     // cancelable: true,    // Event is cancelable
            // });
            // const current = this.$refs[`${this.yPosition}-${this.xPosition}`]
            // console.log("current", current?.[0]?.value)
            // // this.$refs[`${this.yPosition}-${this.xPosition}`]?.[0]?.value = 99
            // current[0].value = 99
            // current?.[0]?.dispatchEvent(event);
            //
            // console.log("current", current?.[0]?.value)

// Dispatch the event on the input element
//            const z =  current?.[0]
//             if (z){
//                 z.value = 88
//             }
//             this.navigate("ArrowDown")
            //

        },
        findTestId(testId, pupild){
           const z = this.testsPure.testList.find(t => {
              return  t.id === `${testId}${pupild}`//&&  t.pupil === pupild

        })
            return z || {date: null}
        },
        getLessonName(subjectId){
          return  getLessonFullName(subjectId)
        },
        getTeacherName(subjectId){
          return  getTeacherFullName(subjectId) || "XXX"
        },
        focusout(event){
            var event = new KeyboardEvent("keydown", {
                key: "Enter",        // The key you want to simulate (Enter in this case)
                code: "Enter",       // The key code for Enter
                keyCode: 13,         // The key code for Enter (13 is Enter's key code)
                which: 13,           // The "which" property for Enter key
                bubbles: true,       // Event bubbles up the DOM tree
                cancelable: true,    // Event is cancelable
            });
            const current = this.$refs[`${this.yPosition}-${this.xPosition}`]

// Dispatch the event on the input element
            current?.[0]?.dispatchEvent(event);
        },
        inputClick(a, b) {
            this.yPosition = a
            this.xPosition = b
            const curr = this.$refs[`${this.yPosition}-${this.xPosition}`]
            this.tempScore = curr?.[0].value
            curr?.[0]?.select()

        },
        onKeydown(event) {
            if (event.shiftKey === false) {
                if (event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "ArrowRight" || event.key === "ArrowLeft") {
                    this.navigate(event.key)
                    event.preventDefault()

                }
            }

        },
        navigate(position) {
            // this.$nextTick(() => {
            const current = this.$refs[`${this.yPosition}-${this.xPosition}`]

            // const event = new Event('change');

            var event = new KeyboardEvent("keydown", {
                key: "Enter",        // The key you want to simulate (Enter in this case)
                code: "Enter",       // The key code for Enter
                keyCode: 13,         // The key code for Enter (13 is Enter's key code)
                which: 13,           // The "which" property for Enter key
                bubbles: true,       // Event bubbles up the DOM tree
                cancelable: true,    // Event is cancelable
            });

// Dispatch the event on the input element
            current?.[0]?.dispatchEvent(event);
            // current?.[0]?.blur();
            // current?.[0]?.focus()
            switch (position) {
                case "ArrowDown": {
                    this.xPosition = (this.xPosition + 1) % this.testList?.length
                    break
                }
                case "ArrowUp": {
                    this.xPosition = (this.testList?.length + (this.xPosition - 1)) % this.testList?.length
                    break

                }
                case "ArrowRight": {
                    this.yPosition = (this.testNames?.length + (this.yPosition - 1)) % this.testNames?.length

                    break

                }
                case "ArrowLeft": {
                    this.yPosition = (this.yPosition + 1) % this.testNames?.length
                    break
                }
            }

            const next = this.$refs[`${this.yPosition}-${this.xPosition}`]
            this.tempScore = next?.[0]?.value
            next?.[0]?.focus()
            next?.[0]?.select()
            this.detailsKey ++

            // });

        },
        showScore(slotProps, testNameId) {
            const score = slotProps?.data[testNameId]
            return score == 0 ? '-' : score
        },
        hebrewDate(date) {
            return dateToOnlyHebrew(date)
        },
        hebrewFullDate(date) {
            return dateToFullHebrew(date)
        },
        async postNewTestName() {
            this.loading = true
            try {
                await postNewTestName(this.nameTestName, this.subject.id, this.dateTestName.getTime(), this.grade.id)
                this.nameTestName = null
                this.dateTestName = null
                await this.fetchData()
                this.isAddTestNameDialog = false

                this.loading = false

            } catch (e) {
                this.loading = false
                console.error(e)
                this.openNotification(
                    "danger",
                    `אופס התרחשה שגיאה`,
                    e
                );
            }
        },
        openAddNameDialog() {
            this.isAddTestNameDialog = true
        },
        async getTestNamesOfUser() {
            const a = {
                userId: this.teacher,
                startDate: this.startDate.getTime(),
                endDate: this.endDate.getTime(),
            }
            const data = await getTestNamesOfUser(a)
            this.testNamesOfUser = data
            console.log("data11", data)

        },
        getPupilName(pupilId) {
            if (pupilId === "00000" ){
                return 'ממוצע כיתה'}
            // return pupilId
            return getPupilFullName(pupilId)
        },
        async fetchData() {
            this.loading = true
            this.testNames = []
            this.testList = []
            this.testsPure = []

            try {
                const a = {
                    grade: this.grade?.id,
                    subject: this.subject?.id,
                    startDate: this.startDate.getTime(),
                    endDate: this.endDate.getTime(),
                }
                const {testsPure, testList, testNames} = await getData(a)
                this.testsPure = testsPure
                this.testNames = testNames
                this.initFilters();
                this.testList = testList

                // this.tableKey ++
                this.loading = false

            } catch (e) {
                console.error(e)
                this.loading = false
                this.openNotification(
                    "danger",
                    ` אופס התרחשה שגיאה`,
                    e
                );
            }

        },
        onCellEditCancel(event){
            this.testList[event.index][event.field] = this.tempScore
        },
        async onCellEditComplete(event) {

            const tempScore = this.tempScore
            if (event.newValue != tempScore && event.newValue !== null) {

                try {
                    const testNameId = this.testNames.find(name => name.id === event.field)

                    const objToPost = {
                        id: event.field + event.newData.pupil || uuidv4(),
                        date: new Date().getTime(),
                        name: testNameId.name,
                        nameId: testNameId,
                        score: event.newValue,
                        subject: this.subject.id,
                        pupil: event.newData.pupil,
                        user: this.user.id,
                        grade: this.grade.id,
                    }
                    this.testList[event.index][event.field] = event.newValue
                    this.$vs.notification({color: "success", position:"right-left", duration : 1000 , loading:true, width: '10%'});

                    await putTest(objToPost)
                } catch (e) {
                    console.error(e)
                    this.openNotification(
                        "danger",
                        `אופס התרחשה שגיאה`,
                        e
                    );

                    this.testList[event.index][event.field] = tempScore

                }
            }
        },
        rowSelected(a,b){
            console.log("123a", a)
            console.log("123b", b)

        },
        pupilClass(x){
            // if (x === 0) return  ' row-bold '

        },
        scoreClass(score, y , x) {
            let style = ""
            // if (x === 0) style += ' row-bold '
            if (y === this.yPosition) style += ' filter-dark '
            if (x === this.xPosition) style += ' filter-dark '
            if (x === this.xPosition && y === this.yPosition) style += ' selected '

            if (score >= 70) return 'green-score' + style
            if (score >= 50) return 'yellow-score'+ style
            if ( score === undefined  || score === null) return  style
            return 'red-score'+ style
        },
        clearFilter() {
            this.initFilters();
        },
        a() {
            return {
                text: [FilterMatchMode.STARTS_WITH, FilterMatchMode.CONTAINS, FilterMatchMode.NOT_CONTAINS, FilterMatchMode.ENDS_WITH, FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS],
                numeric: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS, FilterMatchMode.LESS_THAN, FilterMatchMode.LESS_THAN_OR_EQUAL_TO, FilterMatchMode.GREATER_THAN, FilterMatchMode.GREATER_THAN_OR_EQUAL_TO],
                date: [FilterMatchMode.DATE_IS, FilterMatchMode.DATE_IS_NOT, FilterMatchMode.DATE_BEFORE, FilterMatchMode.DATE_AFTER]
            }
        },
        initFilters() {
            const filters = {}
            this.testNames?.forEach(name => {
                    filters[name.id] = {value: null, matchMode: FilterMatchMode.BETWEEN}
                })
            this.filters = {
                'pupil': {value: null, matchMode: "myfilter"},
                ...filters
                // 'name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
                // 'country.name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
                // 'representative': {value: null, matchMode: FilterMatchMode.IN},
                // 'date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]},
                // 'balance': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
                // 'status': {operator: FilterOperator.OR, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
                // 'activity': {value: null, matchMode: FilterMatchMode.BETWEEN},
                // 'verified': {value: null, matchMode: FilterMatchMode.EQUALS}
            }
        },
        openNotification(color, title, text, position = "right-left", duration = 3000 ) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },
        // getTests() {
        //    return testList
        // }
    },
}
</script>

<style scoped>
>>> .p-datatable table {
    width: auto;
    min-width: unset !important;
    /*width: auto;*/
/*min-width: unset !important;*/
}
>>> input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}

/* Firefox */
>>> input[type=number] {
    -moz-appearance: textfield;
}

/*td:has(> .a){*/
/*    background-color: #92ff7a;*/
/*}*/
/*td:has(> .b) {*/
/*    background-color: #c1ff7a;*/
/*}*/
/*td:has(> .c) {*/
/*    background-color: #ffc37a;*/


/*}td:has(> .d){*/
/*    background-color: #ff7a7a;*/

/*}*/
.p-frozen-column {
    right: 0 !important;
}

>>> .p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th {
    justify-content: center;
}

>>> .p-datatable .p-sortable-column .p-sortable-column-icon {
    margin-left: 0 !important;
    /*transform: scale(0.7);*/
}

>>> .p-column-filter-menu {
    /*transform: scale(0.7);*/
    margin-left: 0 !important;

}

>>> .p-datatable .p-column-header-content {
    text-align: center;
    flex-direction: column-reverse !important;
}

>>> td::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
    width: 0;
    height: 0;
}

>>> html {
    -ms-overflow-style: scrollbar !important; /* IE and Edge */
    scrollbar-width: 30px !important;
}


>>> th::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
    width: 0;
    height: 0;
}

>>> .score-wraper {
    width: -webkit-fill-available;
    height: -webkit-fill-available;
    padding: 0 !important;
    display: flex;
    align-items: center;
}

.score {
    width: -webkit-fill-available;
    text-align: center;
}


/*.qq{*/
/*    background-color: #92ff7a;*/
/*}*/
>>> .p-datatable.p-datatable-gridlines.p-datatable-scrollable .p-datatable-tbody > tr > td + td {
    padding: 0

}

>>> .edit-score {
    user-select: all !important;
    -moz-user-select: all !important;;
    -webkit-user-select: all !important;;
}

.row-bold{
    font-weight: 800;
    background-color: rgba(231, 226, 222, 0.67);
    width: -webkit-fill-available;
    height: -webkit-fill-available;
    padding: 0 !important;
    display: flex;
    align-items: center;

}
.filter-dark{
    background-color: rgba(222, 229, 231, 0.67);
    filter: brightness(0.9);
}
.selected{
    background-color: rgba(147, 204, 222, 0.67);
}
.green-score {
    background-color: rgba(104, 255, 71, 0.67);
}

.yellow-score {
    background-color: rgba(255, 248, 122, 0.63);
}

.red-score {
    background-color: rgba(243, 64, 64, 0.67);
}

.empty {
    background-color: #e7e7e7;
}

>>> .p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(even) {
    background: #f5f5f5;
}

>>> .p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
    padding: 0.3rem 0.3rem;
    /*height: 20px;*/
}

/*.scale-down{*/
/*    transform: scale(0.5);*/

/*}*/

>>> .input-score {
    text-align: center;
    width: -webkit-fill-available;
    height: -webkit-fill-available;
}
</style>